export const pageUrl = {
  profile: {
    edit: '/myaccount',
  },
  change_log : '/change_log',
  cash: {
    flow: {
      importBatches: '/import_batch',
      inputBatches: '/entry_batch',
      pendingBatches: '/batch',
      historyBatches: '/batch_history',
      signature: '/signature_book',
      fraudMonitor: '/fraud_monitor_validation',
      cheque: '/cheque',
    },
    analyse: {
      analyseListe: '/frm_Analyse_CompteCategorie',
    },
    statement: {
      list: '/statement',
      searchadvanched: '/releve_advanced_search',
    },
    alert_account: {
      list: '/statement_alert',
    },
    charges_banques: {
      list: '/fees',
    },
    agios: {
      list: '/frm_Agios',
    },
    mobilityBank: {
      liste: '/banking_mobility',
    },
    fiche_retour: {
      liste: '/frm_FichierRetour',
      details: '/frm_FichierRetour/details/:id',
    },
    repository: {
      company: '/company',
      account: '/account',
      thirdPartyGroup: '/third_party_group',
      thirdParty: '/thirdparty',
      scope: '/scope',
      mandate: '/mandate',
      timeLine: '/timeline',
    },
    settings: {
      user: '/entity_user',
      userGroup: '/user_profile',
      SmartTagSubscription: '/smart-tags',
      eyes: '/frm_validation4yeux',
      college: '/college',
      authority: '/signing_authority',
    },
    jobs: {
      list: '/job',
      controle: '/frm_ControleDemande',
      controle_detail: '/frm_ControleDemande/detail/',
    },
    accounting: {
      rules: '/frm_ComptaRegle',
      entry: '/frm_Ecritures',
      reconciliation: '/frm_Rappro',
      consultation: '/frm_Rappro_consultation',
      history: '/frm_Rappro_Histo',
      closing: '/frm_Rappro_Cloture',
      movement: '/frm_MvtNonRapprochés',
    },
    accountingExport: {
      rule: '/frm_GenerationRegle',
      interface: '/frm_GenerationInterface',
      fog: '/frm_GenerationBrouillard',
    },
    rateAndCurrency: {
      rate: '/rate',
      currency: '/currency',
      fog: '/frm_GenerationBrouillard',
    },
    analyseFlux: {
      liste: '/frm_Analyse_flux_historique',
    },
  },
  administration: {
    settings: {
      category: '/category',
      label: '/frm_Label',
      perimeter: '/frm_Perimetre',
      banque: '/frm_Banque',
      entity: '/frm_Filiale',
      groupSettings: '/settings',
      eyesSettings: '/4eyes_setting',
      group: '/group_setting',
      mobile: '/mobile_setting',
      security: '/security_setting',
      signature: '/signature_setting',
      statement: '/admin_statement',
      rules_statement: '/frm_Rlv_Regle',
      treasuryGroup: '/treasury_profile',
      smartTag: '/frm_SmartTag',
      user: '/user',
      administratorGroup: '/frm_GroupeAdministrateur',
      jobs: '/job_admin',
      documentType: '/frm_TypeDocument',
      groupWidget: '/admin_widget',
      quality: '/frm_Qualite',
      bankHoliday: '/public_holiday',
      powerEbam: '/frm_DescriptionPouvoir',
      commentReport: '/frm_CommentReport',
    },
    communication: {
      connector: '/connector',
      exchangedFiles: '/frm_FichiersRecus',
      treatment: '/post_traitement',
      encryption: '/encryption',
      fraudMonitor: '/fraud_monitor',
    },
    interface: {
      flow: '/flow',
      import: '/import_mapping',
      export: '/export_mapping',
      format: '/format',
      importRule: '/import_rule',
      exportRule: '/export_rule',
    },
    customization: {
      list: '/frm_Liste',
      accountingField: '/frm_ComptaTiers',
      thirdParty: '/frm_CustomTiers',
      method: '/dynamic_method',
      correspondence: '/frm_Correspondance',
      emailTemplate: '/email_template',
      emailRule: '/notification_rule',
      fieldMask: '/frm_MasqueChamp',
      emailStateRule: '/scheduled_task',
      newEmailStateRule: '/scheduled_task/new',
    },
    audit: {
      connection: '/authentication_audit',
      service: '/service',
      hash_file: '/upload_file',
      histo_api: '/call_api',
      gdpr: '/gdpr',
      historyFiles: '/frm_integratedfiles',
      trustedThirdParty: '/trusted_third_party',
    },
    ebam: {
      liste: '/frm_CodeEBAM',
      new: '/frm_CodeEBAM/new',
      edit: '/frm_CodeEBAM/edit/:id',
    },
  },
  treasury: {
    daily: {
      cashpooling: '/cashpooling',
      fiche_valeur: '/Frm_Fiche_en_valeur',
      rappro_histo: '/frm_Treso_RapproHisto',
      search: '/frm_TresoRecherche',
      forecast: '/forecast',
      reconciliation: '/frm_Treso_Rappro',
    },
    event: {
      list: '/frm_Evenement',
    },
    reporting: {
      analyse: '/frm_Analyse',
      analyseSolde: '/frm_AnalyseSolde',
    },
    currentAccount: {
      list: '/frm_ComptesCourants',
      calculation: '/frm_ComptesCourants_Calcul',
      analyse: '/frm_ComptesCourants_Consultation',
    },
    debt: '/frm_Dette',
    analyse_dette: '/frm_DetteAnalyse',
    emprunt: '/frm_Emprunt',
    consultationDette: '/frm_DetteConsultation',
    consultationPlct: '/frm_PlctConsultation',
    analysePlct: '/frm_PlctAnalyse',
    payementEmprunt: '/frm_Emprunt/paiement',
    payement: '/frm_Dette/paiement',
    settings: {
      rate: '/frm_ValeurTaux',
      analyticsCode: '/analytic_code',
      accountGroup: '/account_group',
      reports: '/report',
      etablishExterne: '/external_company',
      remunerationCondition: '/frm_Liste_ValeurTauxObjet',
    },
    placement: {
      compteTitre: {
        liste: '/security_account',
        fiche: '/security_account/new',
        edit: '/security_account/edit/',
        vizualise: '/security_account/:pnIDPlacement/placement/:pnIDValeur',
      },
      compteTerme: {
        liste: '/frm_CAT',
        fiche: '/frm_CAT/new',
        edit: '/frm_CAT/edit/',
        vizualise: '/frm_CAT/:pnIDPlacement/placement/:pnIDValeur',
        payement: '/frm_CAT/paiement',
      },
      valueGestion: {
        liste: '/frm_PlctValeur',
      },
      compteRemunerer: {
        liste: '/frm_PlctLivret',
        create: '/frm_PlctLivret/new',
        edit: '/frm_PlctLivret/edit/',
        visualisation: '/frm_PlctLivret/visualisation',
      },
      compteCapi: {
        liste: '/frm_PlctCapi',
        create: '/frm_PlctCapi/new',
        edit: '/frm_PlctCapi/edit/',
        visualisation: '/frm_PlctCapi/visualisation/',
      },
    },
  },
  document: {
    generation_document: {
      liste: '/frm_GenerationPouvoir',
    },
    signature_document: {
      liste: '/frm_DocumentCollege',
    },
    authority_document: {
      liste: '/frm_PouvoirDocument',
    },
    validation_document: {
      liste: '/frm_ValidationPouvoir',
    },
    sign_list: {
      liste: '/frm_SignatureDocuments',
    },
    gestion_doc_list: {
      liste: '/frm_GestionSignataire',
    },
    history_list: {
      liste: '/frm_HistoriqueDocuments',
    },
    generation_doc_list: {
      liste: '/frm_GenerationPouvoirDocument',
    },
    validation_doc_list: {
      liste: '/frm_ValidationPouvoirDocument',
    },
    DocSociete_generation: {
      liste: '/frm_GenerationDoctSociete',
    },
    DocSociete_validation: {
      liste: '/frm_ValidationDoctSociete',
    },
    mandant: {
      liste: '/frm_GestionMandant',
    },
  },
  risk: {
    operation_change: {
      liste: '/foreign_exchange',
      fiche: '/foreign_exchange/new',
    },
  },
}

